import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { forwardRef, useState } from "react";

interface PriceInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange"
> {
  value: number;
  onChange: (value: number) => void;
  currency?: string;
}

export const PriceInput = forwardRef<HTMLInputElement, PriceInputProps>(
  ({ value, onChange, currency = "€", className, ...props }, ref) => {
    const [displayValue, setDisplayValue] = useState(
      value ? value.toFixed(2) : "",
    );

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value;
      setDisplayValue(inputValue);

      // Parse the value as float
      const numericValue = parseFloat(inputValue) || 0;
      onChange(numericValue);
    };

    const handleBlur = () => {
      // Format on blur
      if (value > 0) {
        setDisplayValue(value.toFixed(2));
      }
    };

    return (
      <div className="relative">
        <Input
          ref={ref}
          type="text"
          inputMode="decimal"
          value={displayValue}
          onChange={handleChange}
          onBlur={handleBlur}
          className={cn("pr-8", className)}
          {...props}
        />
        <div className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none">
          {currency}
        </div>
      </div>
    );
  },
);

PriceInput.displayName = "PriceInput";
